import React, { useEffect } from 'react';
import Modal from 'react-modal';

const StatusBadge = ({ status }) => {
  if (status === 'sending') {
    return (
      <div className="inline-flex items-center text-blue-700 bg-blue-50 border border-blue-200 rounded px-2 py-1 text-sm">
        <i className="bi bi-cloud-upload me-1"></i>
        送信中...
      </div>
    );
  }
  if (status === 'success') {
    return (
      <div className="inline-flex items-center text-green-700 bg-green-50 border border-green-200 rounded px-2 py-1 text-sm">
        <i className="bi bi-check2-circle me-1"></i>
        送信に成功しました
      </div>
    );
  }
  if (status === 'error') {
    return (
      <div className="inline-flex items-center text-red-700 bg-red-50 border border-red-200 rounded px-2 py-1 text-sm">
        <i className="bi bi-x-circle me-1"></i>
        送信に失敗しました
      </div>
    );
  }
  return null;
};

const DiscordTestModal = ({
  isOpen,
  onClose,
  onRetry,
  status, // 'idle' | 'sending' | 'success' | 'error'
  message, // optional detail message
  webhook // string
}) => {
  useEffect(() => {
    // 画面リーダー用にroot指定（NetabareModalと同様の使い方を想定）
    // Modal.setAppElement('#root'); // 既に他所で設定している場合は不要
  }, []);

  const maskedWebhook = React.useMemo(() => {
    if (!webhook) return '';
    try {
      const url = new URL(webhook);
      const id = url.pathname.split('/').pop();
      const head = webhook.slice(0, 35);
      return `${head}.../${id}`;
    } catch {
      return webhook;
    }
  }, [webhook]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="bg-white p-6 rounded-lg shadow-lg mx-auto mt-20 relative max-w-lg w-[92%]"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
    >
      {/* ✕ボタン */}
      <button className="absolute top-4 right-4 text-gray-600 text-lg hover:text-gray-800" onClick={onClose}>
        <i className="bi bi-x-lg"></i>
      </button>

      <div className="px-1">
        <h2 className="font-bold text-purple-800 text-xl mb-2">
          <i className="bi bi-discord me-2"></i>Discord配信テスト
        </h2>

        <div className="text-sm text-gray-600 mb-3 break-all">
          Webhook: {maskedWebhook || '未設定'}
        </div>

        <div className="mb-3">
          <StatusBadge status={status} />
        </div>

        {message && (
          <div className={`text-sm ${status === 'error' ? 'text-red-700' : 'text-gray-700'} bg-gray-50 border rounded p-2`}>{message}</div>
        )}

        <div className="grid grid-cols-2 gap-3 mt-5">
          <button
            type="button"
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-lg px-4 py-2"
            onClick={onClose}
          >
            閉じる
          </button>
          <button
            type="button"
            className="bg-purple-500 hover:bg-purple-600 text-white rounded-lg px-4 py-2 disabled:opacity-60"
            onClick={onRetry}
            disabled={status === 'sending'}
          >
            {status === 'sending' ? '送信中...' : '再送する'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DiscordTestModal;
